import { LOCALES, LOCALE_KEYS } from 'common/constants/locales';

export const checkIsExistLocale = (locale: string) => (
  !!LOCALES[locale as LOCALE_KEYS]
);
